export const DEFAULT_WITH = [
  "customer",
  "repairCategories",
  "technician",
  "store",
  "parts",
  "parts.product",
  "statusHistory",
  "statusHistory.changedBy",
  "laborEntries",
  "laborEntries.technician",
];

export const WITH_OPTIONS = [
  { value: "customer", label: "Customer Details" },
  { value: "repairCategories", label: "Repair Categories" },
  { value: "technician", label: "Assigned Technician" },
  { value: "store", label: "Store Info" },
  { value: "parts", label: "Parts Used" },
  { value: "parts.product", label: "Parts Product Info" },
  { value: "statusHistory", label: "Status History" },
  { value: "statusHistory.changedBy", label: "Status Changed By" },
  { value: "laborEntries", label: "Labor Entries" },
  { value: "laborEntries.technician", label: "Labor Technician" },
];

export const DEFAULT_FILTERS = {
  priority: "",
  status: "",
  repair_category_ids: [],
  store_id: "",
  technician_id: "",
  date_from: "",
  date_to: "",
  sort_by: "created_at",
  sort_direction: "desc",
  with: DEFAULT_WITH,
};

export const ALLOWED_STATUS = [
  "pending",
  "in_progress",
  "awaiting_parts",
  "completed",
  "cancelled",
];

export const ALLOWED_PRIORITY = ["low", "normal", "high", "urgent"];

export const ALLOWED_SORT_BY = [
  "created_at",
  "repair_number",
  "priority",
  "status",
  "estimated_completion_date",
  "total_cost",
];

export const ALLOWED_SORT_DIRECTION = ["asc", "desc"];
